
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"m0 3.79999h24v17h-24z"}})]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"m20.2118 19.4116h-11.57963c-.30898.0001-.6147-.0631-.89835-.1857-.28365-.1225-.53924-.3017-.75104-.5267l-4.84427-5.147c-.39525-.4202-.61532-.9753-.61532-1.5522s.22007-1.1321.61532-1.5523l4.84427-5.14692c.2118-.22497.46739-.40422.75104-.52674s.58937-.18571.89835-.18569h11.57963c.2974-.00006.5919.05848.8667.17227s.5245.2806.7348.49091.3771.45999.4909.73478.1723.56931.1723.86673v10.29386c0 .2975-.0585.592-.1723.8668s-.2806.5244-.4909.7347c-.2103.2104-.46.3772-.7348.491s-.5693.1723-.8667.1722z","stroke":"#4a3428","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.7"}}),_c('g',{attrs:{"fill":"#4a3428"}},[_c('path',{attrs:{"d":"m16.5036 15.1827c-.0687.0001-.1368-.0134-.2003-.0397s-.1212-.0648-.1697-.1135l-5.3186-5.31904c-.0959-.09853-.1492-.23085-.1482-.36833.0009-.13748.0559-.26907.1531-.36631.0971-.09725.2287-.15233.3662-.15333s.2698.05216.3684.14798l5.3191 5.31903c.0732.0732.123.1664.1432.2679s.0099.2067-.0298.3024c-.0396.0956-.1066.1773-.1927.2348-.0861.0574-.1872.0881-.2907.0881z"}}),_c('path',{attrs:{"d":"m11.1849 15.1827c-.1035 0-.2047-.0307-.2907-.0882-.0861-.0574-.1531-.1391-.1927-.2348-.0397-.0956-.05-.2008-.0298-.3023s.07-.1947.1432-.2679l5.3186-5.31904c.0982-.09813.2313-.15326.37-.15326.1388 0 .2719.05513.37.15326.0982.09813.1533.23122.1533.36999 0 .13878-.0551.27187-.1533.37l-5.319 5.31905c-.0485.0486-.1061.0872-.1695.1135s-.1314.0397-.2001.0397z"}})])])])
          )
        }
      }
    